

document.addEventListener('shopify:section:load', function(event){

  divElement = document.querySelector(".header");
  divElement2 = document.querySelector(".notice-bar");

  elemHeight = divElement.offsetHeight + divElement2.offsetHeight;

  document.getElementById('main').style.marginTop = `${elemHeight}px` ;

  noticeBarElement = document.querySelector(".notice-bar");
  noticeBarHeight = noticeBarElement.offsetHeight;
  document.getElementById('header').style.top = `${noticeBarHeight}px` ;


});

document.addEventListener('shopify:block:select', function(event) {



});
document.addEventListener('shopify:block:deselect', function(event) {

});


